import React, { useState } from 'react';

import BusinessIcon from '@mui/icons-material/Business';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Card, Collapse, Grid, IconButton } from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import MapContainer from 'common/components/maps/MapContainer';
import TextLabel from 'common/components/TextLabel';
import TextVariant from 'common/components/TextVariant';
import { DEFAULT_LAT, DEFAULT_LNG } from 'common/constants';

import iconGoogleMaps from 'resources/iconGoogleMaps.svg';

const PreviewLocation = ({ location }) => {
    const [open, setOpen] = useState(false);

    if (!location || !location.position) return null;

    const center = {
        lat: get(location, 'position.latitude', DEFAULT_LAT),
        lng: get(location, 'position.longitude', DEFAULT_LNG),
    };

    const marker = {
        lat: get(location, 'position.latitude'),
        lng: get(location, 'position.longitude'),
        name: location.description,
        title: location.title,
    };

    return (
        <>
            <Card.Body>
                <Grid container>
                    <Grid>
                        <BusinessIcon />
                    </Grid>

                    <Grid size={{ xs: 'grow' }}>
                        <TextVariant
                            text={location.title || 'Sin ubicación'}
                            variant="bold"
                        />
                        <br />
                        <TextVariant
                            text={`(${get(
                                location,
                                'position.latitude',
                                '',
                            )}, ${get(location, 'position.longitude', '')})`}
                        />
                        &nbsp;&nbsp;
                        <a
                            href={`https://www.google.com/maps/search/?api=1&query=${get(
                                location,
                                'position.latitude',
                                '',
                            )},${get(location, 'position.longitude', '')}`}
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            <img
                                alt=""
                                className="img-fluid"
                                src={iconGoogleMaps}
                                width="22px"
                            />
                        </a>
                    </Grid>

                    <Grid>
                        <TextLabel noBorder>
                            <IconButton onClick={() => setOpen(!open)}>
                                {open ? <ExpandLess /> : <ExpandMore />}
                            </IconButton>
                        </TextLabel>
                    </Grid>
                </Grid>
            </Card.Body>

            <Collapse in={open}>
                {open && (
                    <MapContainer center={center} marker={marker} readOnly />
                )}
            </Collapse>
        </>
    );
};

PreviewLocation.propTypes = { location: PropTypes.object };

export default PreviewLocation;
